import { createAsyncAction } from "typesafe-actions";
const domain = "block-player-referral-actions";
const playerReferralActions = {
  changeReferrerInfo: createAsyncAction(
    `${domain}/changeReferrerInfo`,
    `${domain}/changeReferrerInfoSucceed`,
    `${domain}/changeReferrerInfoFailed`
  )(),
  addReferrerInfo: createAsyncAction(`${domain}/addReferrerInfo`, `${domain}/addReferrerInfoSucceed`, `${domain}/addReferrerInfoFailed`)(),
  updateReferrerInfo: createAsyncAction(
    `${domain}/updateReferrerInfo`,
    `${domain}/updateReferrerInfoSucceed`,
    `${domain}/updateReferrerInfoFailed`
  )(),
  removeReferrerInfo: createAsyncAction(
    `${domain}/removeReferrerInfo`,
    `${domain}/removeReferrerInfoSucceed`,
    `${domain}/removeReferrerInfoFailed`
  )(),
  editExpirationDate: createAsyncAction(
    `${domain}/editExpirationDateRequest`,
    `${domain}/editExpirationDateSucceed`,
    `${domain}/editExpirationDateFailure`
  )(),
  editRevenueShare: createAsyncAction(
    `${domain}/editRevenueShareRequest`,
    `${domain}/editRevenueShareSucceed`,
    `${domain}/editRevenueShareFailure`
  )()
};
export {
  playerReferralActions
};
//# sourceMappingURL=actions.js.map
